module.exports = __webpack_public_path__ + "static/media/dropbox-original.98653c34.svg";